














/** @format */

import { Vue, Component, Mixins, Watch } from 'vue-property-decorator';
import GoBackWithCloseTabMixin from '@/common/mixins/go-back-with-close-tab';
import { PARKING_LOT_LIST } from '../router-names';
import AddEditPark from './components/add-edit-park.vue';
// axios请求
import { queryParkingLot, editInfoParkingLot } from '@/api/parking-lot-management/index';
import { isShiDaill } from '@/utils/env';
@Component({
  components: { AddEditPark }
})
export default class ParkingLotListEdit extends Mixins(GoBackWithCloseTabMixin) {
  path = '/smart-parking/parking-lot-management/parking-lot-list/';

  headTitle = '车场编辑'; // 标题
  formData: Record<string, any> = {}; // 表单数据
  parkId = '';
  isshidaill: boolean = isShiDaill;
  // 面包屑数据
  get breadcrumbNav() {
    return [
      {
        label: '车场信息',
        location: {
          name: PARKING_LOT_LIST
        }
      },
      {
        label: this.headTitle
      }
    ];
  }
  // 生命周期初始化
  created() {
    this.parkId = this.$route.params.parkId;
    console.log(this.parkId);
    this.queryEditPark();
  }
  // 获取数据赋值
  async queryEditPark() {
    try {
      const { status, code, msg, data } = await editInfoParkingLot({ parkId: this.parkId });
      if (this.isshidaill) {
        this.formData = {
          ...data,
          pca: [data.provinceId, data.cityId, data.areaId],
          communityCode: data.communityCodeList
        };
      } else {
        this.formData = { ...data, pca: [data.provinceId, data.cityId, data.areaId] };
      }
    } catch (error) {
      console.log(error);
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    }
  }
  // 点击提交
  isSubmitForm(values: any) {
    this.formData = values;
    // this.goBack()
    this.goBack('/smart-parking/parking-lot-management/parking-lot-list');
    // this.$router.replace({
    //   name: PARKING_LOT_LIST,
    //   query: {
    //     search: 'search',
    //   },
    // })
  }
}
